<template>
  <v-container pa-5>
    <v-layout row
              wrap>
      <v-flex xs12
              pt-3>
        <h1>Ontologia: sipam</h1>
      </v-flex>
      <v-flex xs12
              pt-3>
        <v-data-table :headers="headers"
                      :items="items"
                      :hide-default-footer="true"
                      :items-per-page="-1">
          <template v-slot:item.uri="{ item }">
            <span :ref="item.label"
                  v-html="item.uri"></span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "Ontology",
  data () {
    return {
      items: [], headers: [{ text: "URI", value: "uri" }, { text: "Label", value: "label" }, { text: "Comment", value: "comment" }], uri: null
    }
  },
  created () {
    axios.get(this.$conf('VUE_APP_SERVER_URL') + "ontology/sipam").then(response => {
      if (response && response.data) {
        this.items = response.data.map(item => { item.uri = document.location.origin + "/rdf/sipam/terms/" + item.label; return item; });
        if (this.$route.params && this.$route.params.term) {
          // zaznacz i przybliz do konkretnej ontologii
          this.$nextTick(() => {
            var element = this.$refs[this.$route.params.term];
            if (element) {
              element.parentElement.parentElement.style.fontWeight = 'bold';
              element.scrollIntoView();
              if (this.items.map(item => item.label).indexOf(this.$route.params.term) != (this.items.length - 1))
                window.scrollTo(0, window.pageYOffset - 80)
            }
          }, 3000);
        }
      }
    });
  }
}
</script>